module.exports = __webpack_public_path__ + "static/img/comments_user02@2x.f239054f.png";